import { FormattedMessage } from 'react-intl';
import { DateInterest, Facility } from '@/features/accounts/types';
import DateInterestSummary from '@/features/accounts/schedule/components/DateInterestSummary';
import ConfigurationSummaryRow from '@/features/accounts/schedule/configuration/components/ConfigurationSummaryRow';
import FacilityList from '@/features/accounts/schedule/configuration/components/FacilityList';

interface Props {
  interest: DateInterest;
  facilities: Facility[] | null;
}

export default function PreferencesSummary({ interest, facilities }: Props) {
  return (
    <div className="mt-3 space-y-2">
      <ConfigurationSummaryRow labelId="schedule.list.dateRange">
        <DateInterestSummary interest={interest} detail="full" />
      </ConfigurationSummaryRow>
      <ConfigurationSummaryRow labelId="schedule.list.preferredFacilities">
        <FacilityList facilities={facilities} />
      </ConfigurationSummaryRow>
      {interest.max_gap_between_asc_and_consular != null && (
        <ConfigurationSummaryRow labelId="schedule.list.maxGap">
          <FormattedMessage
            id="schedule.list.maxGapDescription"
            values={{ days: interest.max_gap_between_asc_and_consular }}
          />
        </ConfigurationSummaryRow>
      )}
      <ConfigurationSummaryRow labelId="schedule.list.minDaysFromNow">
        <FormattedMessage
          id="schedule.list.minDaysFromNowDescription"
          values={{ days: interest.min_days_from_now }}
        />
      </ConfigurationSummaryRow>
      {interest.min_same_day_gap != null && (
        <ConfigurationSummaryRow labelId="schedule.list.minSameDayGap">
          <FormattedMessage
            id="schedule.list.minSameDayGapDescription"
            values={{ minutes: interest.min_same_day_gap }}
          />
        </ConfigurationSummaryRow>
      )}
      {interest.allow_cancellation && (
        <ConfigurationSummaryRow labelId="schedule.list.allowCancellation">
          <FormattedMessage id="schedule.list.allowCancellationEnabled" />
        </ConfigurationSummaryRow>
      )}
      {interest.accept_worse_date && (
        <ConfigurationSummaryRow labelId="schedule.list.acceptWorseDate">
          <FormattedMessage id="schedule.list.acceptWorseDateEnabled" />
        </ConfigurationSummaryRow>
      )}
    </div>
  );
}
